<script setup lang="ts">
import type { OnboardingState } from '@/services/onboarding'
import { GettersTypes, type State } from '@/store/store_types'
import { computed, ref } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'
import CreateFleetCard from './CreateFleetCard.vue'
import JoinFleetCard from './JoinFleetCard.vue'

const store = useStore<State>()
const { mobile } = useDisplay()
const onboardingState = computed<OnboardingState>(
  () => store.getters[GettersTypes.getOnboardingState],
)
const showDialog = computed(() => {
  return onboardingState.value === 'needs_org'
})

const selectedOption = ref<'create' | 'join' | null>(null)



</script>
<template>
  <v-dialog
    v-model="showDialog"
    :width="mobile ? '100%' : '80%'"
    :height="mobile ? '100%' : '90%'"
    :fullscreen="mobile"
    content-class="rounded-lg"
  >
    <CreateFleetCard v-if="selectedOption === 'create'" @close="selectedOption = null" />
    <JoinFleetCard v-else-if="selectedOption === 'join'" @close="selectedOption = null" />
    <v-card class="rounded-lg pa-6" v-else>
      <v-card-title class="text-h5 text-center"> Welcome to the Essentials! </v-card-title>
      <v-card-subtitle class="text-center mb-4">
        Quick question, are you creating a new fleet or joining an existing one?
      </v-card-subtitle>
      <v-card-text class="d-flex flex-column flex-md-row ga-4 align-center justify-center">
        <v-card
          class="bg-pwt_platinum flex-grow-1 rounded-lg pa-10"
          max-width="400"
          :height="'100%'"
          @click="selectedOption = 'create'"
        >
          <v-card-title class="text-center"> Create new a fleet </v-card-title>
          <v-card-text class="d-flex align-center justify-center pa-4 pt-10 pb-10">
            <v-icon size="64" color="primary">mdi-account-outline</v-icon>
          </v-card-text>
          <v-card-text class="text-center">
            I’m creating an account for myself or my own fleet.
          </v-card-text>
        </v-card>
        <v-card
          class="bg-pwt_platinum flex-grow-1 rounded-lg pa-10"
          max-width="400"
          :height="'100%'"
          @click="selectedOption = 'join'"
        >
          <v-card-title class="text-center"> Join an existing fleet </v-card-title>
          <v-card-text class="d-flex align-center justify-center pa-4 pt-10 pb-10">
            <v-icon size="64" color="primary">mdi-account-group-outline</v-icon>
          </v-card-text>
          <v-card-text class="text-center"> I have an invite code from my fleet admin </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
